import { z } from 'zod';
import { LLM_PROVIDER_ENUM_VALUES, VIEW_TYPE_LABELS } from '../constants';
/** Do not delete this line, it is used to check the enum values */
const assertion = true;
export const llmProviderSchema = z.enum(LLM_PROVIDER_ENUM_VALUES);
const statusKeys = Object.keys(VIEW_TYPE_LABELS);
export const viewTypeSchema = z.enum(statusKeys);
/** Transition scheme with dependent fields */
export const stateTransitionSchema = z.discriminatedUnion("type", [
    z.object({
        type: z.literal("number_of_turns"),
        to: z.string().min(1, "Select the target state"),
        number_of_turns: z.number().min(1, "Minimum 1 turn"),
    }),
    z.object({
        type: z.literal("condition"),
        to: z.string().min(1, "Select the target state"),
        condition: z.string().min(1, "Enter the transition condition"),
    }),
    z.object({
        type: z.literal("tool"),
        to: z.string().min(1, "Select the target state"),
        tool_id: z.number({ required_error: "Select a tool" }),
    }),
]);
const stateConfigSchema = z.object({
    prompt: z.string(),
    tools: z.array(z.number()),
    transition: stateTransitionSchema.optional(),
    is_initial: z.boolean().optional(),
});
export const statesConfigSchema = z.record(z.string(), stateConfigSchema);
export const templatePromptSchema = z.object({
    text: z.string(),
    visible: z.boolean().optional(),
});
export const createLLMSchema = z.object({
    name: z.string().min(1, 'Name is required'),
    model: z.string(),
    states_config: statesConfigSchema,
    view_type: viewTypeSchema
});
export const updateLLMSchema = z.object({
    id: z.number(),
    name: z.string().min(1, 'Name is required'),
    model: z.string().min(1, 'Model is required'),
    provider: llmProviderSchema,
    model_temperature: z.number(),
    template: z.record(templatePromptSchema),
    view_type: viewTypeSchema,
    start_phrase: z.string(),
    states_config: statesConfigSchema,
    test_configuration: z.record(z.string(), z.unknown()),
});
export const duplicateLLMSchema = z.object({
    newName: z.string().min(1, 'Name is required'),
});
